import { requestHandler } from '../../api';

export const fetchAllGiver = async (dispatch: any, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditRequest?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const fetchDetails = async (dispatch: any, creditId: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditRequest/${creditId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createCredit = async (dispatch: any, creditDetails: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/creditRequest`,
    dispatch,
    data: creditDetails,
  });
  if (response) return response.data;
};

export const updateCreditRequestQuote = async (
  dispatch: any,
  creditRequestId: number,
  creditDetails: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/creditRequest/${creditRequestId}/quote`,
    dispatch,
    data: creditDetails,
  });
  if (response) return response.data;
};

export const getCreditRequestBankAccounts = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/creditRequest/${data.id}/bankAccounts`,
    dispatch,
  });
  if (response) return response.data;
};

export const saveCreditRequestPayments = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/creditRequest/${data.id}/payments`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const executeCreditRequestPayouts = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/creditRequest/${id}/payouts/execute`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteCreditLine = async (dispatch: any, id: number) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/creditRequest/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateStatusCreditRequest = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/creditRequest/updateStatus/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const assignOwnerToCreditRequest = async (
  dispatch: any,
  creditRequestId: number,
  ownerId: number,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/creditRequest/${creditRequestId}/assign-owner`,
    dispatch,
    data: { ownerId },
  });
  if (response) return response.data;
};

export const activateCreditRequestWithoutPayouts = async (
  dispatch: any,
  creditRequestId: number,
  executedAt?: Date,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/creditRequest/${creditRequestId}/activate-without-payouts`,
    dispatch,
    data: executedAt ? { executedAt: executedAt.toISOString() } : {},
  });
  if (response) return response.data;
};
